export type AreaPoint = { x: number; y: number };
export function rectanglePoints(a: AreaPoint, b: AreaPoint): AreaPoint[] {
  return [a, { x: b.x, y: a.y }, b, { x: a.x, y: b.y }];
}
/** Reject incomplete/degenerate selections before allocating a raster. */
export function areaBounds(points: AreaPoint[]) {
  if (
    points.length < 3 ||
    points.length > 128 ||
    points.some((p) => !Number.isFinite(p.x) || !Number.isFinite(p.y))
  )
    throw new Error("Choose at least three corners for the area.");
  const x = Math.min(...points.map((p) => p.x)),
    y = Math.min(...points.map((p) => p.y));
  const w = Math.max(...points.map((p) => p.x)) - x,
    h = Math.max(...points.map((p) => p.y)) - y;
  const twiceArea = Math.abs(
    points.reduce((sum, p, i) => {
      const q = points[(i + 1) % points.length];
      return sum + p.x * q.y - q.x * p.y;
    }, 0),
  );
  if (w < 1 || h < 1 || twiceArea < 2) throw new Error("Choose a larger area.");
  return { x, y, w, h };
}
export function captureSize(w: number, h: number) {
  const scale = Math.min(2, 4096 / Math.max(w, h));
  return {
    scale,
    w: Math.max(1, Math.ceil(w * scale)),
    h: Math.max(1, Math.ceil(h * scale)),
  };
}
